import {APP_INITIALIZER, ErrorHandler, LOCALE_ID, NgModule} from '@angular/core';
import {RowStateHighlightDirective} from './directives/row-state-highlight.directive';
import {RowStateBadgeComponent} from './components/shared/row-state-badge/row-state-badge.component';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {AuthInterceptor} from './services/auth/auth.interceptor';
import {AuthStateService} from './services/auth/auth-state.service';
import {ImpersonationBannerComponent} from './components/impersonation-banner/impersonation-banner.component';
import {SortCycleTableDirective} from './directives/sort-cycle-table.directive';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './components/app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {LoginComponent} from './components/login/login.component';
import {HomeComponent} from './components/home/home.component';
import {TopbarComponent} from './components/topbar/topbar.component';
import {MatCardModule} from '@angular/material/card';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatDialogModule} from '@angular/material/dialog';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatMenuModule} from '@angular/material/menu';
import {MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {MatDividerModule} from '@angular/material/divider';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTabsModule} from '@angular/material/tabs';
import {getItalianPaginatorIntl} from './utils/PaginatorFormatter';
import {ClipboardModule} from "@angular/cdk/clipboard";
import {NgxMaterialTimepickerModule} from "ngx-material-timepicker";
import {DatePipe, DecimalPipe, NgForOf, NgOptimizedImage, registerLocaleData} from "@angular/common";
import Bugsnag from '@bugsnag/js';
import {BugsnagErrorHandler} from "@bugsnag/plugin-angular";
import {environment} from "../environments/environment";
import {MAT_RADIO_DEFAULT_OPTIONS, MatRadioModule} from "@angular/material/radio";
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import localeIt from '@angular/common/locales/it'; // to register italian
import {DragDropModule} from "@angular/cdk/drag-drop";
import {CdkAccordionModule} from "@angular/cdk/accordion";
import {MatBadgeModule} from "@angular/material/badge";
import {DxChartModule} from "devextreme-angular/ui/chart"
import {DxCheckBoxModule} from "devextreme-angular/ui/check-box"
import {DxDataGridModule} from "devextreme-angular/ui/data-grid"
import {DxSelectBoxModule} from "devextreme-angular/ui/select-box"
import {DxTooltipModule} from "devextreme-angular/ui/tooltip"
import {MatChipsModule} from "@angular/material/chips";
import {LoggerModule, NgxLoggerLevel} from "ngx-logger";
import {MatInputModule} from '@angular/material/input';
import {MatTableModule} from "@angular/material/table";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSliderModule} from "@angular/material/slider";
import {MatSortModule} from "@angular/material/sort";
import {MatSelectModule} from "@angular/material/select";
import {MatSlideToggleModule} from "@angular/material/slide-toggle";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {MatPaginatorIntl, MatPaginatorModule} from "@angular/material/paginator";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatGridListModule} from "@angular/material/grid-list";
import {DxButtonModule} from "devextreme-angular/ui/button";
import {DxColorBoxModule} from "devextreme-angular/ui/color-box";
import {DxDateBoxModule} from "devextreme-angular/ui/date-box";
import {DxFormModule} from "devextreme-angular/ui/form";
import {DxListModule} from "devextreme-angular/ui/list";
import {DxLoadIndicatorModule} from "devextreme-angular/ui/load-indicator";
import {DxLoadPanelModule} from "devextreme-angular/ui/load-panel";
import {DxLookupModule} from "devextreme-angular/ui/lookup";
import {DxNumberBoxModule} from "devextreme-angular/ui/number-box";
import {DxPopoverModule} from "devextreme-angular/ui/popover";
import {DxPopupModule} from "devextreme-angular/ui/popup";
import {DxProgressBarModule} from "devextreme-angular/ui/progress-bar";
import {DxRadioGroupModule} from "devextreme-angular/ui/radio-group";
import {DxResponsiveBoxModule} from "devextreme-angular/ui/responsive-box";
import {DxScrollViewModule} from "devextreme-angular/ui/scroll-view";
import {DxSwitchModule} from "devextreme-angular/ui/switch";
import {DxTabPanelModule} from "devextreme-angular/ui/tab-panel";
import {DxTextBoxModule} from "devextreme-angular/ui/text-box";
import {DxToastModule} from "devextreme-angular/ui/toast";
import {DxToolbarModule} from "devextreme-angular/ui/toolbar";
import {DxValidatorModule} from "devextreme-angular/ui/validator";
import {DxoItemDraggingModule} from "devextreme-angular/ui/nested/";
import {DxDrawerModule} from "devextreme-angular/ui/drawer"
import {DxDropDownBoxModule} from "devextreme-angular/ui/drop-down-box"
import {DxDropDownButtonModule} from "devextreme-angular/ui/drop-down-button"
import {DxRangeSelectorModule} from "devextreme-angular/ui/range-selector"
import {DxTextAreaModule} from "devextreme-angular/ui/text-area"
import {DxTreeListModule} from "devextreme-angular/ui/tree-list"
import {DxValidationGroupModule} from "devextreme-angular/ui/validation-group"
import {DashboardComponent} from './components/dashboard/dashboard.component';
import {GridsterComponent, GridsterItemComponent} from "angular-gridster2";
import {WidgetHeaderComponent} from './components/widget/common/WidgetHeader/WidgetHeader.component';
import {MultiChartWidgetComponent} from './components/widget/multi-chart-widget/multi-chart-widget.component';
import {FavouriteSitesComponent} from './components/widget/favourite-sites/favourite-sites.component';
import {FavouriteSiteComponent} from './components/widget/favourite-site/favourite-site.component';
import {ThreeDimModelWidgetComponent} from './components/widget/three-dim-model/three-dim-model-widget.component';
import {OrderByPipe} from './pipes/order-by.pipe';
import {EmptyComponent} from './components/empty/empty.component';
import {PartitionComponent} from './components/registry/partition/partition.component';
import {UserComponent} from './components/registry/user/user.component';
import {DeviceTypeComponent} from './components/registry/device-type/device-type.component';
import {TDViewerModule} from "@aiknow-srl/aik-ngx-3dviewer";
import {ChartsComponent} from './components/charts/charts.component';
import {DashboardFormComponent} from './components/dashboard/dashboard-form/dashboard-form.component';
import {GatewayTypeComponent} from './components/registry/gateway-type/gateway-type.component';
import {ChartFormEditComponent} from './components/charts/chart-form/chart-form-drawer/chart-form-edit.component';
import {
  ChartFormCreationComponent
} from './components/charts/chart-form/chart-form-popup/chart-form-creation.component';
import {ChartControlsComponent} from './components/topbar/chart-controls/chart-controls.component';
import {
  ChartMetricsTableComponent
} from './components/charts/chart-form/chart-form-drawer/chart-metrics-table/chart-metrics-table.component';
import {MeasureCardsComponent} from './components/widget/measure-cards/measure-cards.component';
import {GatewayDeviceComponent} from './components/registry/gateway-device/gateway-device.component';
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {
  ChartTimeSelectorComponent
} from './components/topbar/chart-controls/chart-time-selector/chart-time-selector.component';
import {MqttManagerModule} from "@aiknow-srl/aik-ngx-mqtt";
import {DiagnosticComponent} from './components/alarm/diagnostic/diagnostic.component';
import {AlertComponent} from './components/alarm/alert/alert.component';
import {ThreeDimModelFormComponent} from './components/widget/three-dim-model/three-dim-model-form.component';
import {ThreeDimViewerComponent} from './components/widget/three-dim-model/three-dim-viewer.component';
import {BaseAlarmComponent} from './components/alarm/common/baseAlarm.component';
import {MetricSelectorComponent} from './components/common/metric-selector/metric-selector.component';
import {PartitionSelectorComponent} from './components/common/partition-selector/partition-selector.component';
import {DeviceSelectorComponent} from './components/common/device-selector/device-selector.component';
import {AlertFormComponent} from './components/alarm/alert/alert-form/alert-form.component';
import {DxMenuModule, DxSortableModule, DxTagBoxModule} from "devextreme-angular";
import {
  MainMeasureCardComponent
} from './components/widget/measure-cards/main-measure-card/main-measure-card.component';
import {
  SecondaryMeasureCardComponent
} from './components/widget/measure-cards/secondary-measure-card/secondary-measure-card.component';
import {ResetPasswordComponent} from './components/reset-password/reset-password.component';
import {ForgotPasswordComponent} from './components/login/forgot-password/forgot-password.component';
import {ChangePasswordComponent} from './components/topbar/change-password/change-password.component';
import {AlarmTimeSelectorComponent} from './components/alarm/common/alarm-time-selector/alarm-time-selector.component';
import {VirtualMeasuresComponent} from './components/registry/virtual-measures/virtual-measures.component';
import {CronSelectorComponent} from './components/registry/virtual-measures/cron-selector/cron-selector.component';
import {CronInputComponent} from './components/common/cron-input/cron-input.component';
import {
  ExpressionFunctionsComponent
} from './components/registry/virtual-measures/expression-functions/expression-functions.component';
import {NotFoundComponent} from './components/not-found/not-found.component';
import {WidgetPlaceholderComponent} from './components/widget/common/widget-placeholder/widget-placeholder.component';
import {TopbarSelectorsComponent} from './components/topbar/topbar-selectors/topbar-selectors.component';
import {TopbarButtonsComponent} from './components/topbar/topbar-buttons/topbar-buttons.component';
import {
  ModbusMetricTableComponent
} from './components/registry/device-type/measures-protocol-forms/modbus-metric-table/modbus-metric-table.component';
import {
  BaseProtocolFormComponent
} from './components/registry/device-type/measures-protocol-forms/base-protocol-form/base-protocol-form.component';
import {
  S7MetricTableComponent
} from './components/registry/device-type/measures-protocol-forms/s7-metric-table/s7-metric-table.component';
import {
  ModbusGroupTableComponent
} from './components/registry/device-type/measures-protocol-forms/modbus-group-table/modbus-group-table.component';
import {
  S7GroupTableComponent
} from './components/registry/device-type/measures-protocol-forms/s7-group-table/s7-group-table.component';
import {
  MeasureCardFormComponent
} from './components/widget/measure-cards/measure-card-form/measure-card-form.component';
import {
  GatewayTableComponent
} from './components/registry/gateway-device/gateway/gateway-table/gateway-table.component';
import {DeviceTableComponent} from './components/registry/gateway-device/device/device-table/device-table.component';
import {
  DeviceEditFormComponent
} from './components/registry/gateway-device/device/device-edit-form/device-edit-form.component';
import {
  MeasureGroupTableComponent
} from './components/registry/gateway-device/device/measure-group-table/measure-group-table.component';
import {
  MeasureMetricTableComponent
} from './components/registry/gateway-device/device/measure-metric-table/measure-metric-table.component';
import {
  DeviceTemplateCompareComponent
} from './components/registry/gateway-device/device/device-template-compare/device-template-compare.component';
import {
  DeviceCreateFormComponent
} from './components/registry/gateway-device/device/device-create-form/device-create-form.component';
import {
  GatewayEditFormComponent
} from './components/registry/gateway-device/gateway/gateway-edit-form/gateway-edit-form.component';
import {
  GatewayCreateFormComponent
} from './components/registry/gateway-device/gateway/gateway-create-form/gateway-create-form.component';
import { HexTextBoxComponent } from './components/common/hex-text-box/hex-text-box.component';
import Clarity from '@microsoft/clarity';
import { UserReportComponent } from './components/report/user-report.component';
import { UserReportFormComponent } from './components/report/user-report-form/user-report-form.component';
import { UserReportMetricsTableComponent } from './components/report/user-report-metrics-table/user-report-metrics-table.component';
import { DuplicateEntityPopupComponent } from './components/topbar/topbar-selectors/duplicate-entity-popup/duplicate-entity-popup';
import { SortCycleTreeDirective } from './directives/sort-cycle-tree.directive';
import { WeeklySelectorComponent } from './components/weekly-selector/weekly-selector.component';
import { WeekGridComponent } from './components/weekly-selector/week-grid/week-grid.component';

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/languages/', '.json');
}

registerLocaleData(localeIt);

if (environment.production) {
  Bugsnag.start({apiKey: 'f2fbbd9166508e2f1659f2666d323646'});
}

if (environment.clarityProjectId) {
  Clarity.init(environment.clarityProjectId);
  Clarity.consent(false);
  if ((globalThis as any)._clarityConsent === 'grant') {
    Clarity.consentV2();
  } else {
    const onConsent = (e: any) => {
      if (e.detail === 'grant') {
        Clarity.consentV2();
        window.removeEventListener('clarityConsent', onConsent);
      }
    };
    window.addEventListener('clarityConsent', onConsent);
  }
}


// create a factory which will return the Bugsnag error handler
export function errorHandlerFactory() {
  if (environment.production) {
    return new BugsnagErrorHandler();
  } else {
    return new ErrorHandler();
  }
}

@NgModule({
  declarations: [
    AppComponent,
    ImpersonationBannerComponent,
    SortCycleTableDirective,
    SortCycleTreeDirective,
    LoginComponent,
    HomeComponent,
    TopbarComponent,
    DashboardComponent,
    WidgetHeaderComponent,
    MultiChartWidgetComponent,
    FavouriteSitesComponent,
    FavouriteSiteComponent,
    ThreeDimModelWidgetComponent,
    OrderByPipe,
    EmptyComponent,
    PartitionComponent,
    UserComponent,
    DeviceTypeComponent,
    ChartsComponent,
    DashboardFormComponent,
    GatewayTypeComponent,
    ChartFormEditComponent,
    ChartFormCreationComponent,
    ChartControlsComponent,
    ChartMetricsTableComponent,
    GatewayDeviceComponent,
    ChartMetricsTableComponent,
    MeasureCardsComponent,
    ChartTimeSelectorComponent,
    ThreeDimModelFormComponent,
    ThreeDimViewerComponent,
    DiagnosticComponent,
    AlertComponent,
    BaseAlarmComponent,
    MetricSelectorComponent,
    PartitionSelectorComponent,
    DeviceSelectorComponent,
    AlertFormComponent,
    MainMeasureCardComponent,
    SecondaryMeasureCardComponent,
    ResetPasswordComponent,
    ForgotPasswordComponent,
    ChangePasswordComponent,
    AlarmTimeSelectorComponent,
    VirtualMeasuresComponent,
    CronSelectorComponent,
    CronInputComponent,
    ExpressionFunctionsComponent,
    NotFoundComponent,
    WidgetPlaceholderComponent,
    TopbarSelectorsComponent,
    TopbarButtonsComponent,
    ModbusMetricTableComponent,
    S7MetricTableComponent,
    ModbusGroupTableComponent,
    S7GroupTableComponent,
    MeasureCardFormComponent,
    GatewayTableComponent,
    DeviceTableComponent,
    DeviceEditFormComponent,
    MeasureGroupTableComponent,
    MeasureMetricTableComponent,
    DeviceTemplateCompareComponent,
    DeviceCreateFormComponent,
    GatewayEditFormComponent,
    GatewayCreateFormComponent,
    HexTextBoxComponent,
    UserReportComponent,
    UserReportFormComponent,
    UserReportMetricsTableComponent,
    RowStateHighlightDirective,
    RowStateBadgeComponent,
    DuplicateEntityPopupComponent,
    WeeklySelectorComponent,
    WeekGridComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG,
      enableSourceMaps: true,
      colorScheme: ['black', 'black', 'teal', 'gray', 'orange', 'red', 'purple'],
      timestampFormat: 'dd/MM/yyyy HH:mm:ss.SSS (z)',
      disableFileDetails: false,
    }),
    TDViewerModule,
    MatCardModule,
    MatSnackBarModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    MatCheckboxModule,
    MatSliderModule,
    MatDialogModule,
    MatSortModule,
    MatSelectModule,
    MatSidenavModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatMenuModule,
    MatToolbarModule,
    MatIconModule,
    MatTableModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatProgressSpinnerModule,
    MatDividerModule,
    MatTabsModule,
    MatPaginatorModule,
    MatExpansionModule,
    // MQTT
    MqttManagerModule,
    HttpClientModule,
    ClipboardModule,
    NgxMaterialTimepickerModule,
    MatRadioModule,
    MatGridListModule,
    DragDropModule,
    CdkAccordionModule,
    MatBadgeModule,
    MatChipsModule,
    DxDataGridModule,
    DxSelectBoxModule,
    DxCheckBoxModule,
    DxTooltipModule,
    DxChartModule,
    DxResponsiveBoxModule,
    DxButtonModule,
    DxoItemDraggingModule,
    DxLoadPanelModule,
    DxTabPanelModule,
    DxListModule,
    DxNumberBoxModule,
    DxRadioGroupModule,
    DxFormModule,
    DxLoadIndicatorModule,
    DxPopupModule,
    DxDateBoxModule,
    DxValidatorModule,
    DxPopoverModule,
    DxProgressBarModule,
    DxToastModule,
    DxScrollViewModule,
    DxSwitchModule,
    DxColorBoxModule,
    DxTextBoxModule,
    DxLookupModule,
    DxToolbarModule,
    NgOptimizedImage,
    DxTextAreaModule,
    DxTreeListModule,
    DxValidationGroupModule,
    NgForOf,
    GridsterComponent,
    GridsterItemComponent,
    DxDrawerModule,
    DxRangeSelectorModule,
    DxDropDownBoxModule,
    DxDropDownButtonModule,
    MatProgressBarModule,
    DxTagBoxModule,
    DxMenuModule,
    DxSortableModule,
    TranslateModule
  ],
  providers: [{provide: MatPaginatorIntl, useValue: getItalianPaginatorIntl()}, {
    provide: ErrorHandler,
    useFactory: errorHandlerFactory
  },
    {
      provide: MAT_RADIO_DEFAULT_OPTIONS,
      useValue: {color: 'primary'},
    },
    {provide: LOCALE_ID, useValue: 'it-IT'},
    {provide: MAT_DATE_LOCALE, useValue: 'it-IT'},
    // {provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS},
    DatePipe, DecimalPipe, OrderByPipe,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
    {
      provide: APP_INITIALIZER,
      useFactory: (authState: AuthStateService) => () => authState.restoreSession(),
      deps: [AuthStateService],
      multi: true
    }],
  bootstrap: [AppComponent]
})
export class AppModule {
}
